module.exports = __webpack_public_path__ + "static/media/icon-customer-new.7aca326f.svg";